import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { SolutionMedia } from "src/app/shared/interfaces/media";
import { ModalService } from "src/app/shared/data-access/modal.service";

@Component({
  selector: "app-media-item",
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatIconModule],
  template: `
    <div class="media-item-container d-flex align-items-start">
      <div class="media-item">
        <span class="qundis-inter-400">
          <i [class]="getIconType(mediaItem.type)"></i>
          {{
            mediaItem.name.length < 12
              ? mediaItem.name
              : mediaItem.name.split("").slice(0, 11).join("") + "..."
          }}
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="menuButton"
            class="menu-button"
            (click)="openMenu($event)"
          >
            <i class="bi bi-chevron-down"></i>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="renameMediaItem(mediaItem)">
              <i class="bi bi-pencil-square"></i>
              <span> Datei umbenennen</span>
            </button>
            <button mat-menu-item (click)="deleteMediaItem(mediaItem)">
              <i class="bi bi-trash"></i>
              <span> Datei löschen</span>
            </button>
          </mat-menu>
        </span>
      </div>
    </div>
  `,
  styles: [
    `
      .media-item {
        padding: 2px 3px;
        margin-right: 5px;
        border: 1px solid black;
        border-radius: 4px;
        cursor: pointer;
      }
      .menu-button {
        border: none;
        background-color: transparent;
      }
    `,
  ],
})
export class MediaItemComponent {
  @Input() mediaItem: any;
  @Output() newDeleteEvent = new EventEmitter<SolutionMedia>();
  @Output() newEditEvent = new EventEmitter<SolutionMedia>();

  modalService = inject(ModalService);

  isMenuOpen = signal<boolean>(false);

  openMenu(event: Event) {
    event.stopPropagation();
  }

  deleteItem() {
    window.confirm("Möchten Sie die Datei wirklich löschen?");
  }

  getIconType(type: string) {
    if (type.includes("pdf")) {
      return "bi bi-file-earmark-text";
    } else if (type.includes("image")) {
      return "bi bi-image";
    } else if (type.includes("video")) {
      return "bi bi-youtube";
    } else {
      return;
    }
  }

  renameMediaItem(item: any) {
    console.log(item);
    // open modal
    this.newEditEvent.emit(item);
    this.modalService.openModal("editMediaItemModal");
    // update path in media table
    // update storage object
  }

  deleteMediaItem(item: SolutionMedia) {
    console.log(item);
    this.newDeleteEvent.emit(item);
    // show confirmation dialog
    // delete storage object
    // delete reference from media table
  }
}
